var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="noAuth_empty"> <div class="container-scroller"> <div class="container-fluid page-body-wrapper full-page-wrapper"> <div class="content-wrapper d-flex align-items-center text-center error-page bg-primary"> <div class="row flex-grow"> <div class="col-lg-7 mx-auto text-white"> <div class="row align-items-center d-flex flex-row"> <div class="col-lg-6 text-lg-right pr-lg-4"> <h1 class="display-1 mb-0">'+
((__t=( resources['X200179'] ))==null?'':__t)+
'</h1> </div> <div class="col-lg-6 error-page-divider text-lg-left pl-lg-4"> <h2>'+
((__t=( resources['X200182'] ))==null?'':__t)+
'</h2> <h3 class="font-weight-light">'+
((__t=( resources['X200180'] ))==null?'':__t)+
'</h3> <h3 class="font-weight-light">'+
((__t=( resources['X200252'] ))==null?'':__t)+
'</h3> </div> </div> <div class="row mt-5"> <div class="col-12 mt-xl-2"> <p class="text-white font-weight-medium text-center">'+
((__t=( resources['X200181'] ))==null?'':__t)+
'</p> </div> </div> </div> </div> </div>  </div>  </div> </div>';
}
return __p;
};
